export default "__VITE_PUBLIC_ASSET__5f3081ab__"